jQuery(function ($) {
    $('.zip-button').click(function () {
        // 郵便番号から住所を自動入力
        AjaxZip3.zip2addr('zip', '', 'address', 'address');
    });

    $('.zipclient-button').click(function () {
        // 郵便番号から住所を自動入力
        AjaxZip3.zip2addr('zipclient', '', 'addressclient', 'addressclient');
    });

    $('.zipproperty-button').click(function () {
        // 郵便番号から住所を自動入力
        AjaxZip3.zip2addr('zipproperty', '', 'addressproperty', 'addressproperty');
    });
});